import ArticleHeroImageContainer from './ArticleHeroImageContainer'

export default ArticleHeroImageContainer
